<template>
    <div>
        <Button
            @click="submit"
            :iconName="isEnabled ? 'stop' : 'play'"
            color="light"
            size="small"
            iconClass="size-4"
            :loading="apiFormRef?.loading.valueOf()"
        >
            <slot />
        </Button>
        <ApiForm
            :url="updateUrl"
            method="POST"
            ref="apiFormRef"
        >
            <input
                type="hidden"
                :name="RequestBodyKeyEnum.App_Automation_Update_State"
                :value="
                    isEnabled
                        ? AutomationStateEnum.Disabled
                        : AutomationStateEnum.Enabled
                "
            />
        </ApiForm>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Automation from '@/App/Automation/Entity/Automation'
    import type ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import {
        AutomationStateEnum,
        ResponseJsonKeyEnum,
    } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const emits = defineEmits<{
        onSuccess: [{ automation: Automation }]
    }>()

    const props = defineProps({
        isEnabled: {
            type: Boolean,
            required: true,
        },
        updateUrl: {
            type: String,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            const updateAutomation = response.getHydratedAutomation(
                ResponseJsonKeyEnum.App_Automation_Update_AutomationData,
            )

            emits('onSuccess', {
                automation: updateAutomation,
            })
        })
    }
</script>
